import React from 'react';

import { IVehicleDetails } from '@/types';
import { CarCard } from '../carCard';

import * as Styles from './styles';

type CarouselProps = {
    activeIndex: number;
    setActiveIndex: (index: number) => void;
    savedAssets?: IVehicleDetails[];
};

const Carousel = ({
    activeIndex,
    setActiveIndex,
    savedAssets = [],
}: CarouselProps) => {
    const handleSlideChange = (index: number) => {
        setActiveIndex(index);
    };

    if (!savedAssets || savedAssets.length <= 0) {
        return null;
    }

    return (
        <Styles.CarCardList>
            {savedAssets.map((asset, index) => (
                <CarCard
                    active={index === activeIndex}
                    carData={asset}
                    onClick={() => handleSlideChange(index)}
                    key={index}
                />
            ))}
        </Styles.CarCardList>
    );
};

export default Carousel;
